module.exports = __webpack_public_path__ + "media/images/patent/y_5-bf0178d5e10ccda4bf217166d0e26fc5.jpg";